import { useCallback, useRef, useState } from "react";
import type { CSSProperties, RefObject } from "react";

type UseNavUnderlineResult = {
  containerRef: RefObject<HTMLUListElement>;
  underlineRef: RefObject<HTMLDivElement>;
  underlineStyle: CSSProperties;
  updateUnderline: () => void;
};

const ACTIVE_CLASS = "active-nav-link";

const useNavUnderline = (
  activeClass: string = ACTIVE_CLASS
): UseNavUnderlineResult => {
  const containerRef = useRef<HTMLUListElement | null>(null);
  const underlineRef = useRef<HTMLDivElement | null>(null);
  const [underlineStyle, setUnderlineStyle] = useState<CSSProperties>({});

  const updateUnderline = useCallback(() => {
    const container = containerRef.current;
    if (!container) {
      setUnderlineStyle({});
      return;
    }

    const activeLink = container.querySelector(
      `.${activeClass}`
    ) as HTMLElement | null;

    if (!activeLink) {
      setUnderlineStyle({});
      return;
    }

    const { offsetLeft, offsetWidth } = activeLink;
    setUnderlineStyle({
      left: offsetLeft,
      width: offsetWidth,
      height: "2px",
      backgroundColor: "#00c6ff",
      position: "absolute",
      bottom: 0,
      transition: "all 0.3s ease",
    });
  }, [activeClass]);

  return { containerRef, underlineRef, underlineStyle, updateUnderline };
};

export default useNavUnderline;
